import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('visual-model')
export class VisualModel extends LitElement {

	static styles = css`
	  :host {
		display: block;
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<svg-model></svg-model>
		`;
	}
}
